export default __webpack_public_path__ + "static/media/6.edff3a15.png";